import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import SocialProofSection from '../components/SocialProofSection';
import PromoBanner from '../components/PromoBanner';
import SEO from '../components/SEO';
import { seoData } from '../data/seoData';
import { Users, Award, BookOpen, Target, CheckCircle, Star } from 'lucide-react';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <SEO {...seoData.about} />
      <PromoBanner />
      <Navigation />
      
      {/* About Zero to Cloud Section */}
      <section className="pt-24 pb-20 bg-white">
        <div className="container">
          <div className="max-w-6xl mx-auto">
            <h1 className="heading-large text-gray-900 mb-12 text-center">
              About
            </h1>
            
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-12">
              {/* Left side - Image */}
              <div className="order-2 lg:order-1">
                <img 
                  src="/about-hero-image.png" 
                  alt="Zero to Cloud Learning"
                  className="rounded-xl shadow-lg w-full max-w-sm mx-auto"
                />
              </div>
              
              {/* Right side - Content */}
              <div className="order-1 lg:order-2 text-center lg:text-left">
                <h2 className="heading-large text-gray-900 mb-6">
                  Zero To Cloud
                </h2>
                <p className="body-large text-gray-600 mb-6 leading-relaxed">
                  Zero to Cloud simplifies cloud learning and prepares learners for success in the cloud industry.
                </p>
                <p className="body-large text-gray-600 mb-8 leading-relaxed">
                  Our interactive e-learning platform provides high quality learning materials covering certifications, fun and accessible projects, and resume & interview preparation.
                </p>
                
                <div className="mb-8">
                  <p className="body-large text-gray-700 mb-4 font-medium">
                    The platform includes:
                  </p>
                  <ul className="space-y-3 text-gray-600">
                    <li className="flex items-start gap-3">
                      <span className="text-purple-600 font-bold">•</span>
                      <span>Cloud projects from Beginner to Advanced.</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="text-purple-600 font-bold">•</span>
                      <span>Comprehensive study notes for AWS Certifications.</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="text-purple-600 font-bold">•</span>
                      <span>Access to a supportive Slack community.</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Meet the Instructor Section */}
      <section className="py-20 bg-gray-50">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <h2 className="heading-large text-gray-900 mb-8 text-center">
              Meet Your Instructor
            </h2>
            
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div className="text-center">
                <p className="body-large text-gray-600 mb-6 leading-relaxed">
                  Lucy Wang is the founder of Zero to Cloud and Tech With Lucy.
                </p>
                <p className="body-large text-gray-600 mb-6 leading-relaxed">
                  As an ex-AWS Solutions Architect with over 5 years of Cloud experience, she is passionate about helping people build their technical skills and achieve their career goals.
                </p>
                <p className="body-large text-gray-600 leading-relaxed">
                  Lucy has personally mentored over 200+ Cloud Learners and her mission is to make cloud learning fun and accessible for everyone.
                </p>
              </div>
              
              <div className="relative">
                <img 
                  src="/instructor-thumbnail.png" 
                  alt="Lucy Wang - Instructor"
                  className="rounded-xl shadow-lg w-full max-w-md mx-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <SocialProofSection />
      <Footer />
    </div>
  );
};

export default AboutPage;